import script from "./AnalyticsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsPage.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsPage.vue?vue&type=style&index=0&id=2fe7f525&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe7f525"]])

export default __exports__